var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"breakdance-notification-error breakdance-notification-error"},[_c('div',{staticClass:"breakdance-notification-message"},[_c('div',{staticClass:"breakdance-notification-message-body"},[_vm._v(" "+_vm._s(_vm.value.message)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }